var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { UserType } from './Enums';
const Default = {
    companyId: 1,
    nationalId: { value: '19120415-1234', country: 'SE' },
    id: 2,
    firstName: 'Ann',
    lastName: 'Vändare',
    email: 'noreply@tofindout.se',
    userType: UserType.Candidate,
    birthDate: "",
    language: 'Svenska',
    phoneNumber: '+46701112233'
};
export class Candidate {
    constructor(individual = Default) {
        this.fromJson(individual);
    }
    fromJson(individual) {
        this.companyId = individual.companyId;
        this.nationalId = individual.nationalId;
        this.id = individual.id;
        this.firstName = individual.firstName;
        this.lastName = individual.lastName;
        this.email = individual.email;
        this.userType = individual.userType;
        this.language = individual.language;
        this.phoneNumber = individual.phoneNumber;
    }
    toJson() {
        return {
            companyId: this.companyId,
            nationalId: this.nationalId,
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            userType: this.userType,
            birthDate: this.birthDate,
            language: this.language,
            phoneNumber: this.phoneNumber
        };
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}
__decorate([
    observable
], Candidate.prototype, "companyId", void 0);
__decorate([
    observable
], Candidate.prototype, "nationalId", void 0);
__decorate([
    observable
], Candidate.prototype, "id", void 0);
__decorate([
    observable
], Candidate.prototype, "firstName", void 0);
__decorate([
    observable
], Candidate.prototype, "lastName", void 0);
__decorate([
    observable
], Candidate.prototype, "email", void 0);
__decorate([
    observable
], Candidate.prototype, "userType", void 0);
__decorate([
    observable
], Candidate.prototype, "birthDate", void 0);
__decorate([
    observable
], Candidate.prototype, "language", void 0);
__decorate([
    observable
], Candidate.prototype, "phoneNumber", void 0);
__decorate([
    action
], Candidate.prototype, "fromJson", null);
__decorate([
    action
], Candidate.prototype, "toJson", null);
__decorate([
    computed
], Candidate.prototype, "fullName", null);
